/**
 * UI Components - Moon Moon Agency  
 * Handles dropdowns, splide carousels, and loader states
 */

/*********************************************************************************************
 * 🚀 LOADER MODULE
 */
const LoaderManager = {
	// Local configuration
	config: {
		classes: {
			loading: 'mm-loading',
			active: 'mm-active'
		},
		selectors: {
			dropdownTrigger: '[data-dropdown-trigger]'
		}
	},

	/**
	 * Add loading state to specified element
	 */
	loadThis(elem) {
		if (!elem) {
			window.log('warn', 'LoaderManager', 'No element provided');
			return;
		}
		elem.classList.add(this.config.classes.loading);
		window.emit('global:loader-activated', { element: elem.tagName });
	}
};

/*********************************************************************************************
 * 📋 DROPDOWN MODULE
 */
const DropdownManager = {
	/**
	 * Initialize dropdown behaviors
	 */
	init() {
		const dropWrappers = window.getElements(LoaderManager.config.selectors.dropdownTrigger);
		if (!dropWrappers.length) return;

		dropWrappers.forEach((item) => {
			item.addEventListener('click', function() {
				// Close other dropdowns
				dropWrappers.forEach((el) => {
					if (el !== this) {
						el.classList.remove(LoaderManager.config.classes.active);
						if (el.nextElementSibling) {
							el.nextElementSibling.style.maxHeight = null;
						}
					}
				});

				// Toggle current dropdown
				this.classList.toggle(LoaderManager.config.classes.active);
				const content = this.nextElementSibling;

				if (content) {
					const isActive = this.classList.contains(LoaderManager.config.classes.active);
					content.style.maxHeight = isActive ? `${content.scrollHeight}px` : null;
					
					window.emit('global:dropdown-toggled', { 
						active: isActive, 
						element: this.tagName 
					});
				}
			});
		});

	}
};


/*********************************************************************************************
 * 🎠 SPLIDE MODULE
 */
const SplideManager = {
	/**
	 * Initialize all Splide carousels with their data-splide configurations
	 */
	init() {
		const splideElements = window.getElements('.splide');
		if (!splideElements.length || !window.Splide) return;

		let initializedCount = 0;
		const sectionsWithSplide = [];

		splideElements.forEach(element => {
			try {
				const configData = element.dataset.splide;
				if (configData) {
					// Nettoyer et vérifier la validité du JSON
					const cleanedData = configData
						.replace(/'/g, '"')  // Remplacer les quotes simples par doubles
						.replace(/(\w+):/g, '"$1":');  // Ajouter des guillemets aux clés sans guillemets
					
					const config = JSON.parse(cleanedData);
					new Splide(element, config).mount();
				} else {
					// Configuration par défaut si pas de data-splide
					new Splide(element).mount();
				}
				
				// Collecter les sections
				const sectionElement = element.closest('section');
				if (sectionElement) {
					const sectionName = sectionElement.className || 'unnamed-section';
					if (!sectionsWithSplide.includes(sectionName)) {
						sectionsWithSplide.push(sectionName);
					}
				}
				
				initializedCount++;

			} catch (error) {
				window.log('error', 'SplideManager', `JSON parsing failed for element: ${element.className}`);
				window.log('error', 'SplideManager', `Data-splide: ${element.dataset.splide}`);
				
				// Initialiser avec config par défaut en cas d'erreur
				try {
					new Splide(element).mount();
					initializedCount++;
				} catch (fallbackError) {
					window.log('error', 'SplideManager', `Fallback initialization failed: ${fallbackError.message}`);
				}
			}
		});

		// Émettre un seul événement global avec la liste des sections
		window.emit('global:splide-initialized', {
			count: initializedCount,
			sections: sectionsWithSplide
		});
	}
};

/*********************************************************************************************
 * 🎯 UI COMPONENTS MANAGER
 */
const UIComponentsManager = {
	/**
	 * Initialize all UI components
	 */
	init() {
		DropdownManager.init();
		SplideManager.init();
	}
};

/*********************************************************************************************
 * 🌍 GLOBAL ACCESS
 */
window.LoaderManager = LoaderManager;
window.DropdownManager = DropdownManager;  
window.SplideManager = SplideManager;
window.UIComponentsManager = UIComponentsManager;

/*********************************************************************************************
 * 🔄 BACKWARD COMPATIBILITY
 */
window.mmLoadThis = (elem) => LoaderManager.loadThis(elem);
window.handleDropdown = () => DropdownManager.init();
window.mmSplide = () => SplideManager.init();

/*********************************************************************************************
 * 🎯 AUTO-INITIALIZATION
 */
document.addEventListener('DOMContentLoaded', () => {
	UIComponentsManager.init();
});